import { render, staticRenderFns } from "./PermissionRoleUpload.vue?vue&type=template&id=03c6380a&scoped=true&"
import script from "./PermissionRoleUpload.vue?vue&type=script&lang=js&"
export * from "./PermissionRoleUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c6380a",
  null
  
)

export default component.exports